<header class="header">
  <section>
    <form *ngIf="filters" [formGroup]="filters" (submit)="onFilterSubmited()" class="dateFilterForm">

      <mat-form-field>
        <mat-label>Entrer une période</mat-label>
        <mat-date-range-input formGroupName="range" [rangePicker]="picker">
          <input matStartDate formControlName="fromStartDate" placeholder="Du" (focus)="picker.open()">
          <input matEndDate formControlName="toStartDate" placeholder="Au" (focus)="picker.open()">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <button mat-icon-button type="submit" color="primary" matTooltip="Filtrer">
        <mat-icon>
          search
        </mat-icon>
      </button>

      <button type="button" mat-icon-button color="primary" matTooltip="Effacer les dates"
        (click)="onResetFiltersSubmited()">
        <mat-icon>
          clear
        </mat-icon>
      </button>
    </form>
  </section>
</header>

<main class="datatable-container">
  <div class="menuDisplayedColumns">
    <button mat-mini-fab color="primary" matTooltip="Préférences des colonnes" [matMenuTriggerFor]="menu">
      <mat-icon>list</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <div cdkDropList (cdkDropListDropped)="drop($event)">
        <div *ngFor="let displayedColumn of displayedColumnsMenu" cdkDrag>
          <section class="menu-item" (click)="$event.stopPropagation()">
            <ng-container *ngIf="displayedColumn.editable">
              <mat-checkbox class="example-margin" [checked]="displayedColumn.selected"
                (change)="onSelectMenu($event,displayedColumn.name)">
                {{ 'billing.pre-billing.history.list.' + displayedColumn.name | translate }}
              </mat-checkbox>
            </ng-container>
          </section>
        </div>
      </div>
    </mat-menu>

  </div>

  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChanged($event)">
    <ng-container matColumnDef="client">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'billing.pre-billing.history.list.client' | translate}}
      </th>
      <td mat-cell *matCellDef="let history">{{ history.client.name }}</td>
    </ng-container>

    <ng-container matColumnDef="site">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'billing.pre-billing.history.list.site' | translate}}
      </th>
      <td mat-cell *matCellDef="let history">{{ history.site.name }}</td>
    </ng-container>

    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'billing.pre-billing.history.list.fileName' | translate}}
      </th>
      <td mat-cell *matCellDef="let history">{{ history.document.fileName }}</td>
    </ng-container>

    <ng-container matColumnDef="totalPrice">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'billing.pre-billing.history.list.totalPrice' | translate}}
      </th>
      <td mat-cell *matCellDef="let history">{{ history.totalPrice }} €</td>
    </ng-container>

    <ng-container matColumnDef="startDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'billing.pre-billing.history.list.startDate' | translate}}
      </th>
      <td mat-cell *matCellDef="let history">{{ history.startDate | amDateFormat: 'DD/MM/YYYY' }}</td>
    </ng-container>

    <ng-container matColumnDef="endDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'billing.pre-billing.history.list.endDate' | translate}}
      </th>
      <td mat-cell *matCellDef="let history">{{ history.endDate | amDateFormat: 'DD/MM/YYYY' }}</td>
    </ng-container>

    <ng-container matColumnDef="createdOn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'billing.pre-billing.history.list.createdOn' | translate}}
      </th>
      <td mat-cell *matCellDef="let history">{{ history.createdOn | amDateFormat: 'DD/MM/YYYY HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'billing.pre-billing.history.list.actions' | translate}}
      </th>
      <td mat-cell *matCellDef="let history">
        <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
          [matTooltip]="'billing.pre-billing.history.list.delete' | translate" (click)="deleteFile(history)">
          <mat-icon aria-label="Edit">delete</mat-icon>
        </button>

        <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
          [matTooltip]="'billing.pre-billing.history.list.download' | translate" (click)="download(history)">
          <mat-icon aria-label="Edit">save_alt</mat-icon>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let proForma; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator *ngIf="pagination" [pageSize]="pagination.pageSize" [length]="pagination.totalRecords"
    [pageIndex]="pagination.pageNumber - 1" (page)="onPageChanged($event)" showFirstLastButtons></mat-paginator>
  <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
</main>